import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';

// This route only makes sense once Authentik's Email stage template is
// customized to link here (https://<frontend>/verify-email?token=...)
// instead of its own default /if/flow/... page. Until that template
// change is made, clicking the email link still opens Authentik's own
// hosted UI directly — see chat history for why (flow_token must be
// nested inside the executor API's `query=` param, confirmed working
// via curl on 2026-07-12, but that's a backend-only fact; the email
// itself still needs to be told to link here).
export default function VerifyEmailCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('This verification link is missing its token.');
      return;
    }

    fetch(`${API_BASE}/auth/register/verify-email?token=${encodeURIComponent(token)}`, {
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          setError('This verification link is invalid or has expired.');
          return;
        }
        // Success — go back to the main registration page, which will
        // fetch the current (now-advanced) challenge on mount and show
        // whatever stage comes next (consent, then TOTP setup).
        navigate('/register', { replace: true });
      })
      .catch(() => setError('Could not reach the registration service.'));
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh', boxSizing: 'border-box',
      backgroundImage: 'url(/BESCOM_SSO_BG_Image.png)', backgroundSize: 'cover', backgroundPosition: 'center',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.65)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.5)', borderRadius: '16px',
        padding: '32px 40px', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.35)',
      }}>
        <p style={{ margin: 0, color: error ? '#B3261E' : '#666', fontSize: '14px' }}>
          {error || 'Verifying your email…'}
        </p>
      </div>
    </div>
  );
}
